/* eslint-disable */
export default {
  to: 'Naar:',
  enterNameOrPhoneNumber: 'Nummer invoeren',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
